(function(w, d) {
    w.__tnt || (w.__tnt = {});
    w.__tnt.subscription || (__tnt.subscription = {});
    w.__tnt.subscription.access || (__tnt.subscription.access = {});
    __tnt.subscription.access.previousTab || (__tnt.subscription.access.previousTab = []);
    
    w.userStatus = d.createEvent('Event');
    userStatus.initEvent('tnt-user-status', true, true);
    userStatus.version = 3;
    userStatus.hasAccess = false;
    userStatus.accessMethod = 'none';
    userStatus.accessError = null;
    
    w.tntPurchase = d.createEvent('Event');
    tntPurchase.initEvent('tnt-purchase', true, true, {});
    
    w.addEventListener('tnt-user-status', function(ev) {
        var offerEl = d.getElementById('access-offers-container'), 
            modalWrapperEl = d.getElementById('access-offers-modal'),
            modalEl = null,
            purchaseTab = d.getElementById('user-modal-tab-purchase'),
            purchaseForm = d.getElementById('form-super-purchase'),
            errorTab = d.getElementById('modal-error-tab'),
            templateEl = null,
            headerEl = null,
            outputEl = null,
            siteNameEl = d.head.querySelector('meta[property="og:site_name"]'),
            siteName = "",
            limit = offerEl.querySelector('template').dataset.offerLimit,
            previewMode = false,
            context = "organic",
            legacyContext = "Block";
        
        if (siteNameEl) {
            siteName = siteNameEl.content
        }
        if (modalWrapperEl) {
            modalEl = modalWrapperEl.querySelector('.modal');
            if (modalWrapperEl.hasAttribute('data-preview')) {
                previewMode = true
            }
        }
        
        if (offerEl) {
            templateEl = offerEl.querySelector('template');
            headerEl = offerEl.querySelector('header');
            outputEl = offerEl.querySelector('.output');
        }
        
        TNCMS.Access.getOfferGroups().then(function(data) {
            var sessionOffer = sessionStorage.getItem('__tnt.access.offers_id'),
                offerId = sessionOffer ? sessionOffer : templateEl.dataset.offerId,
                offerGroup = data[offerId];

            if (!offerGroup) {
                var offerIter = 0;
                
                while (!offerGroup && offerIter < Object.keys(data).length) {
                    if (Object.keys(data)[offerIter] != "undefined") {
                        offerGroup = data[Object.keys(data)[offerIter]];
                        console.log("ERROR: Subscription - No valid offer group found for " + offerId +", using group " + offerGroup.id);
                    }
                    offerIter++;
                }
                if (!offerGroup) {
                    d.querySelector('.access-methods-list').innerHTML = '<div class="alert alert-warning">No offers are currently available.</div>';
                    throw ("ERROR: Subscription - no valid offer group found");
                }
            }
            
            /* Populate contents of the offer display */
            __tnt.subscription.offers.populate(offerGroup, outputEl, headerEl, templateEl, limit, context, legacyContext, function(t, offer) {
                // Callback actions on each template item
                var descriptionEl = t.querySelector('.method-description'),
                    descriptionElH4 = null;
                
                if (descriptionEl) {
                    descriptionElH4 = descriptionEl.querySelector('h4');
                    
                    if (descriptionElH4) {
                        descriptionElH4.addEventListener('click', function(ev) {
                            ev.target.parentNode.classList.toggle('hide-mobile');
                        });
                    }
                }
                
                /** Offer click event listener */
                t.querySelector('a.method-link').addEventListener('click', function(ev) {
                    ev.preventDefault();

                    __tnt.events.signedIn.detail.type = 'organic';
                    __tnt.events.signedUp.detail.type = 'organic';
                    
                    if (ev.target) {
                        /* Get product data from target element */
                        var productData = JSON.parse(ev.target.getAttribute('data-product'));
                    }
                    
                    if (ev.target.getAttribute('data-subscription-service')) {
                        var serviceId = ev.target.getAttribute('data-subscription-service'),
                            serviceName = ev.target.getAttribute('data-name'),
                            rateId = ev.target.getAttribute('data-subscription-rate'),
                            rateEl = d.getElementById('user-purchase-rate'),
                            rateName = ev.target.getAttribute('data-subscription-rate-name');
                        __tnt.subscription.access.previousTab = [];
                        // Populate purchase form detail
                        __tnt.subscription.offers.purchaseDetails(offer, siteName, serviceName, serviceId, rateId, rateEl, rateName, purchaseTab, purchaseForm, previewMode, productData)
                        .then(function() {
                            // Show purchase tab
                            __tnt.subscription.access.showTab(purchaseTab, "access-offers-modal", "access-methods", true);
                            $(modalEl).modal('show');
                            purchaseForm.dispatchEvent(tntPurchase);
                        }).catch(function(e) {
                            console.log(e);
                            __tnt.subscription.access.showTab(errorTab, "access-offers-modal", "access-methods", true);
                            $(modalEl).modal('show');
                        });
                    } else {
                        if (ev.target.href != "javascript:void(0)") {
                            d.location = ev.target.href;
                        }
                    } // end service check
                });
            }).then(function(data) {
                if (!previewMode) {
                    __tnt.subscription.offers.logImpression(data);
                }
            });
            
        }).catch(function(e) {
            console.log(e);
        });
    });
})(window, document);